// extracted by mini-css-extract-plugin
export var bold = "_sq-0";